import React from "react";
import {
  Code,
  FlipVerticalIcon,
  Palette,
  Server,
  Database,
  ShoppingBag,
} from "lucide-react";

const Services = ({ isDarkMode }) => {
  const services = [
    {
      icon: <Code className="w-10 h-10" />,
      title: "Web Development",
      description:
        "Complete custom websites and web applications using cutting-edge technologies like React, Next.js, Node.js, and modern JavaScript frameworks. From simple landing pages to complex enterprise solutions with responsive design and optimal performance.",
      gradient: "from-blue-500 to-cyan-500",
    },
    {
      icon: <FlipVerticalIcon className="w-10 h-10" />,
      title: "Video Editing & Content Creation",
      description:
        "Professional video editing services including promotional videos, social media content, motion graphics, and visual storytelling. Creating engaging posts, reels, thumbnails, and branded content for various platforms and marketing campaigns.",
      gradient: "from-green-500 to-emerald-500",
    },
    {
      icon: <Palette className="w-10 h-10" />,
      title: "UI/UX Design",
      description:
        "User-centered design solutions that perfectly blend aesthetics with functionality. Creating intuitive interfaces, wireframes, prototypes, and complete design systems that enhance user experience and drive engagement across all digital platforms.",
      gradient: "from-purple-500 to-pink-500",
    },
    {
      icon: <Server className="w-10 h-10" />,
      title: "Backend Development",
      description:
        "Robust and scalable server-side solutions including RESTful APIs, microservices architecture, database integration, authentication systems, and cloud deployment. Ensuring secure, fast, and reliable backend infrastructure for any application.",
      gradient: "from-orange-500 to-red-500",
    },
    {
      icon: <Database className="w-10 h-10" />,
      title: "Database Design",
      description:
        "Comprehensive database architecture and optimization services including schema design, query optimization, data modeling, migration strategies, and performance tuning for MySQL, PostgreSQL, MongoDB, and other database systems.",
      gradient: "from-indigo-500 to-purple-500",
    },
    {
      icon: <ShoppingBag className="w-10 h-10" />,
      title: "Shopify Development",
      description:
        "Complete Shopify store development and customization including theme development, app integration, payment gateway setup, inventory management, and performance optimization. Creating powerful e-commerce solutions that drive sales and growth.",
      gradient: "from-teal-500 to-blue-500",
    },
  ];

  return (
    <section
      id="services"
      className={`py-10 transition-all duration-500 ${
        isDarkMode ? "bg-gray-900" : "bg-gray-50"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className={`text-5xl md:text-6xl font-bold mb-6 ${
              isDarkMode ? "text-white" : "text-gray-900"
            }`}
          >
            Services
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-6"></div>
          <p
            className={`text-xl max-w-3xl mx-auto ${
              isDarkMode ? "text-gray-300" : "text-gray-600"
            }`}
          >
            I offer comprehensive digital solutions to help bring your ideas to
            life
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group p-6 rounded-2xl transition-all duration-500 hover:scale-105 hover:shadow-2xl ${
                isDarkMode
                  ? "bg-gray-800 hover:bg-gray-700 border border-gray-700"
                  : "bg-white hover:bg-gray-50 shadow-lg"
              }`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div
                className={`bg-gradient-to-r ${service.gradient} p-4 rounded-xl inline-block mb-6 group-hover:scale-110 transition-transform duration-300`}
              >
                <div className="text-white">{service.icon}</div>
              </div>
              <h3
                className={`text-2xl font-bold mb-4 ${
                  isDarkMode ? "text-white" : "text-gray-900"
                }`}
              >
                {service.title}
              </h3>
              <p
                className={`leading-relaxed ${
                  isDarkMode ? "text-gray-300" : "text-gray-600"
                }`}
              >
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
